module.exports = __webpack_public_path__ + "static/sunset-816515a2df57fbb80480dcba05c905b2.png";